<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
<app-alert [Type]="AlertType" [View]="AlertStatus" [Message]="AlertMessage"></app-alert>
<div class="mx-5 pb-5">
  <app-pages-header></app-pages-header>
  <div class="bg-white bottom-page-shadow rounded-bottom-extra mx-1 pb-5">
    <div class="p-3">
      <p> <span class="fw-bold">Penyenggaraan</span> - Log Audit </p>
    </div>
    <div class="row rounded-top-extra primary-colour shadow mx-5">
      <div class="col pt-2">
        <p>Log Audit</p>
      </div>
    </div>
    <div class="row rounded-bottom-extra shadow mx-5" style="background-color: #F5F5F5 !important;">
      <div class="col m-3">
        <div class="row">
          <div class="col-3">
            <select class="form-select border-0 shadow" [(ngModel)]="ModuleInput" [ngModelOptions]="{standalone: true}" (change)="OnChangeModule(ModuleInput)">
              <option value="">Modul</option>
              <option value="Pembayar Cukai">Pembayar Cukai</option>
              <option value="Integrasi">Integrasi</option>
              <option value="Penyenggaraan">Penyenggaraan</option>
            </select>
          </div>
          <div class="col-4 offset-1" [ngClass]="ModuleInput === '' ? 'd-none' : '' " (change)="OnChangePage(PageInput)">
            <select class="form-select border-0 shadow" [(ngModel)]="PageInput" [ngModelOptions]="{standalone: true}">
              <option value="">Halaman</option>
              <option *ngFor="let res of PageViewList" [value]="res.Name">{{res.Value}}</option>
            </select>
          </div>
          <div class="col-3  offset-1" *ngIf="ViewActionStatus">
            <select class="form-select border-0 shadow" [(ngModel)]="ActionInput" [ngModelOptions]="{standalone: true}">
              <option value="">Tindakan</option>
              <option *ngFor="let res of ActionViewList" [value]="res.Name">{{res.Value}}</option>
            </select>
          </div>
        </div>
        <div class="row pt-4">
          <div class="col-3">
            <input type="text" id="startdate" class="form-control border-0 shadow" placeholder="Tarikh Mula" autocomplete="off" readonly="readonly">
          </div>
          <div class="col-1">
            <p class="text-center">sehingga</p>
          </div>
          <div class="col-3">
            <input type="text" id="enddate" class="form-control border-0 shadow" placeholder="Tarikh Hingga" autocomplete="off" readonly="readonly">
          </div>
        </div>
        <div class="row pt-4">
          <div class="col-3">
            <select class="form-select border-0 shadow" [(ngModel)]="SearchTypeInput" [ngModelOptions]="{standalone: true}" (change)="OnChangeSearchType()">
              <option value="">Jenis Carian</option>
              <option value="pc">Pembayar Cukai</option>
              <option value="pt">Pengguna TAeF</option>
            </select>
          </div>
          <div class="col-3 offset-1" *ngIf="SearchTypeInput === 'pc'">
            <input type="number" class="form-control border-0 shadow" [(ngModel)]="TINInput" [ngModelOptions]="{standalone: true}" placeholder="TIN Pembayar Cukai">
          </div>
          <div class="col-3 offset-1" *ngIf="SearchTypeInput === 'pt'">
            <select class="form-select border-0 shadow" [(ngModel)]="IDTypeInput" [ngModelOptions]="{standalone: true}">
              <option value="">Jenis Pengenalan</option>
              <option value="1">MyKad/MyPR/MyKAS</option>
              <option value="2">No. Pasport/Dokumen lain</option>
              <!--<option value="3">Tentera</option>-->
              <!--<option value="4">Polis</option>-->
            </select>
          </div>

          <div class="col-3 offset-1" *ngIf="SearchTypeInput === 'pt'">
            <input type="text" class="form-control border-0 shadow" [(ngModel)]="IDNoInput" [ngModelOptions]="{standalone: true}" placeholder="No. Pengenalan">
          </div>
        </div>
        <div class="row pt-4">
          <div class="col">
            <div class="btn-toolbar d-flex justify-content-end ">
              <div class="me-2">
                <button type="button" class="btn grey-default-button border-0 shadow rounded-4" role="button" (click)="Semula()">Semula</button>

              </div>
              <div class="me-2">
                <button type="button" class="btn submit-button border-0 shadow rounded-4" role="button" (click)="Hantar(ModuleInput,PageInput,ActionInput,SearchTypeInput,IDTypeInput,IDNoInput,TINInput)">Hantar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mx-5 py-1" *ngIf="SearchStatus">
      <div class="pt-5">
        <p>Senarai Log Audit</p>
        <!--<input #input type="text" (keyup)="applyFilter($event)" class="form-control w-25 mb-2 border-0 shadow" placeholder="Carian" aria-label="Carian" aria-describedby="basic-addon1">-->
      </div>
      <div class="example-table-container">
        <table mat-table [dataSource]="dataSource" class="w-100 shadow">
          <ng-container matColumnDef="pcname">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Nama Pembayar Cukai</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.EmployerName !== 'N/A'  ? res.EmployerName : res.taxPayerName}}</td>
          </ng-container>
          <ng-container matColumnDef="tin">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>TIN Pembayar Cukai</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.taxPayerItRefNo}}</td>
          </ng-container>
          <ng-container matColumnDef="module">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Modul</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.modul}}</td>
          </ng-container>
          <ng-container matColumnDef="page">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Halaman</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.halaman}}</td>
          </ng-container>
          <ng-container matColumnDef="tindakan">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tindakan</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.tindakan}}</td>
          </ng-container>
          <ng-container matColumnDef="staffname">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Nama Staff</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.staffName}}</td>
          </ng-container>
          <ng-container matColumnDef="staffidno">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>No. Pengenalan Staf</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.staffIdno}}</td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tindakan</th>
            <td mat-cell *matCellDef="let res">
              <div class="btn-toolbar d-flex justify-content-center">
                <div class="me-2">
                  <button type="button" (click)="ViewDetail(res)" data-bs-toggle="modal" data-bs-target="#viewModal" class="btn submit-primary-button border-0 shadow rounded-2 bg-white" role="button">Papar</button>
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let test;columns:displayedColumns"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center" colspan="10">Tiada Rekod</td>
          </tr>
        </table>
        <mat-paginator class="mat-evelation-z8" (page)="paginatorEvent($event)" [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[10,15,20]" [length]="RecordCount">
        </mat-paginator>
      </div>
    </div>
  </div>
</div>



<!-- View Log Modal -->
<div class="modal fade" id="viewModal" tabindex="-1" aria-labelledby="viewModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content pb-5" style="background-color: #E8E8E8 !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-end align-items-end pb-3">
          <button class="btn" data-bs-dismiss="modal"><i class="bi bi-x-square-fill"></i></button>

        </div>
        <div class="row rounded-top-extra primary-colour shadow mx-3">
          <div class="col pt-2">
            <p>Maklumat Carian</p>
          </div>
        </div>

        <div class="rounded-bottom-extra shadow mx-3" style="background-color: #F5F5F5 !important;">
          <div class="row mx-2 pt-3">
            <div class="col-2">
              <p>Tarikh dan Masa</p>
            </div>
            <div class="col-1">
              <p class="text-end">:</p>
            </div>
            <div class="col-3">
              <p class="fw-bold">{{DateDetailView}}</p>
            </div>
          </div>
          <div class="row mx-2">
            <div class="col-2">
              <p>Nama Staf</p>
            </div>
            <div class="col-1">
              <p class="text-end">:</p>
            </div>
            <div class="col-3">
              <p class="fw-bold text-uppercase">{{StaffNameDetailView}}</p>
            </div>
          </div>
          <div class="row mx-2">
            <div class="col-2">
              <p>No. Pengenalan Staf</p>
            </div>
            <div class="col-1">
              <p class="text-end">:</p>
            </div>
            <div class="col-3">
              <p class="fw-bold text-uppercase">{{StaffIDNoDetailView}}</p>
            </div>
          </div>
          <div class="row mx-2">
            <div class="col-2">
              <p>Modul</p>
            </div>
            <div class="col-1">
              <p class="text-end">:</p>
            </div>
            <div class="col-3">
              <p class="fw-bold text-uppercase">{{ModuleDetailView}}</p>
            </div>
          </div>
          <div class="row mx-2">
            <div class="col-2">
              <p>Halaman</p>
            </div>
            <div class="col-1">
              <p class="text-end">:</p>
            </div>
            <div class="col-6">
              <p class="fw-bold text-uppercase">{{PageDetailView}}</p>
            </div>
          </div>
          <div class="row mx-2">
            <div class="col-2">
              <p>Tindakan</p>
            </div>
            <div class="col-1">
              <p class="text-end">:</p>
            </div>
            <div class="col-3">
              <p class="fw-bold text-uppercase">{{ActionDetailView}}</p>
            </div>
          </div>
          <div class="row mx-2">
            <div class="col-2">
              <p>Nama Pembayar Cukai</p>
            </div>
            <div class="col-1">
              <p class="text-end">:</p>
            </div>
            <div class="col-3">
              <p class="fw-bold text-uppercase">{{TaxPayerNameDetailView}}</p>
            </div>
          </div>
          <div class="row mx-2">
            <div class="col-2">
              <p>No. Cukai Pembayar Cukai</p>
            </div>
            <div class="col-1">
              <p class="text-end">:</p>
            </div>
            <div class="col-3">
              <p class="fw-bold text-uppercase">{{TaxRefNumDetailView}}</p>
            </div>
          </div>
          <div class="row mx-2">
            <div class="col-2">
              <p>Huraian</p>
            </div>
            <div class="col-1">
              <p class="text-end">:</p>
            </div>
            <div class="col-6">
              <p class="fw-bold text-uppercase">{{DescriptionDetailView}}</p>
            </div>
          </div>
          <div class="btn-toolbar d-flex justify-content-end pt-2 pb-3">
            <div class="me-2">
              <button type="button" data-bs-dismiss="modal" class="btn grey-default-button border-0 shadow rounded-4" role="button">Kembali</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
